import styled, { keyframes } from "styled-components";
import { mediaQueryMaxMedium } from "../../mediaQuery";
import { SIDEBAR, TRANSITION_SPEED } from "./constants";
import { useSidebarState } from "./state";

export const HEADER_HEIGHT_MOBILE = 64;

const open = (from: "left" | "right") => keyframes`
 from {
  transform: translateX(${from === "left" ? "-100%" : "100%"})
 } 
 to {
  transform: translateX(0)
 }
`;

type MenuContainerProps = {
  openMobileFrom: "left" | "right";
};

// This component wraps the menu, just inside the Sidebar. It is responsible for
// showing the actual menu in the correct size. When the sidebar is collapsed it
// This component contains all the visual styles for the actual menu.
export const MenuContainer = styled.div.attrs((props: MenuContainerProps) => ({
  ...props,
  ...useSidebarState(),
}))`
  position: relative;
  display: flex;
  align-items: baseline;
  background-color: var(--sinch-sys-color-container-main-default);
  box-sizing: border-box;
  width: ${({ isCollapsed }) =>
    isCollapsed ? SIDEBAR.collapsedWidth : SIDEBAR.width}px;
  transition: width ${TRANSITION_SPEED}s;
  border-right: 1px solid
    var(--sinch-sys-color-container-contrast-primary-active);
  height: 100vh;

  ${mediaQueryMaxMedium} {
    width: 100%;
    animation: ${({ openMobileFrom }) => open(openMobileFrom)} 0.3s;
    height: calc(100vh - ${HEADER_HEIGHT_MOBILE}px);
  }
`;
